import { api } from '@rd-web-markets/shared/dist/services/service';
const generalRouteSubRouteService = {
  get: function (id, route, subRoute) {
    let subRouteId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return api.get(`/${route}/${id}/${subRoute}/${subRouteId}`);
  },
  getAll: function (id, route, subRoute) {
    let queries = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return api.get(`/${route}/${id}/${subRoute}${queries}`);
  },
  update: function (id, route, subRoute) {
    let subRouteId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    let body = arguments.length > 4 ? arguments[4] : undefined;
    return api.update(`/${route}/${id}/${subRoute}/${subRouteId}`, body);
  },
  delete: function (id, route, subRoute) {
    let subRouteId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
    return api.delete(`/${route}/${id}/${subRoute}/${subRouteId}`);
  },
  create: function (id, route, subRoute) {
    let body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    return api.create(`/${route}/${id}/${subRoute}`, body);
  },
  putFormData: function (id, route, subRoute) {
    let body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
    let subRouteId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
    return api.putFormData(`/${route}/${id}/${subRoute}/${subRouteId}`, body);
  },
  postFormData: (id, route, subRoute, body) => api.postFormData(`/${route}/${id}/${subRoute}`, body)
};
export default generalRouteSubRouteService;